import AppBar from "components/AppBar"
import { Grid } from "@material-ui/core"
import TimeSwitch, { TimeStatus } from "components/TimeSwitch"
import { useIntl } from "react-intl"
import React from "react"
import usePlanningCalendar from "app/hooks/usePlanningCalendar"
import { StyledRightContainer } from "../../PersonalPlanningView/PersonalPlanningNavigation/PersonalPlanningNavigationBar/style"
import { PlanningNavigationProps } from "../PlanningNavigation/types"

const MobilePlanningNavigation: React.FC<PlanningNavigationProps> = () => {
  const { messages } = useIntl()
  const { date, setDate } = usePlanningCalendar()

  const handleDateChange = (status: TimeStatus) => {
    const currentDate = date.clone()
    const updatedDate = status === "add" ? currentDate.add(1, "week") : currentDate.subtract(1, "week")
    setDate(updatedDate)
  }

  return (
    <AppBar
      rightComponent={
        <StyledRightContainer>
          <Grid item={true}>
            <TimeSwitch
              title={`${messages["general.dates.week"]} ${date.isoWeek()}`}
              onDateChange={handleDateChange}
              iconColor="inherit"
            />
          </Grid>
        </StyledRightContainer>
      }
    />
  )
}

export default MobilePlanningNavigation
